"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Page = (function () {
    function Page(page) {
        if (page === void 0) { page = { startIndex: 0, maxItems: Page.DefaultMaxItems }; }
        this.startIndex = page.startIndex;
        this.maxItems = page.maxItems;
    }
    Page.prototype.from = function (startIndex) {
        return new Page({ startIndex: startIndex, maxItems: this.maxItems });
    };
    Page.prototype.size = function (maxItems) {
        return new Page({ startIndex: this.startIndex, maxItems: maxItems });
    };
    /*
     Up to but including the given index
     */
    Page.prototype.to = function (endIndex) {
        return new Page({ startIndex: this.startIndex, maxItems: Math.max(0, endIndex - this.startIndex) });
    };
    Page.prototype.next = function (maxItems) {
        if (maxItems === void 0) { maxItems = this.maxItems; }
        return new Page({ startIndex: this.startIndex + maxItems, maxItems: maxItems });
    };
    Page.DefaultMaxItems = 100;
    return Page;
}());
exports.Page = Page;
//# sourceMappingURL=Page.js.map